var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-sheet',{staticClass:"d-flex flex-column justify-center align-center"},[_c('v-icon',{attrs:{"color":"primary","size":"60"}},[_vm._v(" mdi-tag-outline ")]),_c('v-sheet',{staticClass:"text-h3 mt-5"},[_vm._v(" "+_vm._s(_vm.$t('no_views'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }